var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82.9 103.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-4{fill:#00a6e4;}.cls-1,.cls-2,.cls-3{stroke:#00a6e4;stroke-linecap:round;stroke-miterlimit:10;}.cls-1,.cls-2{stroke-width:3.48px;}.cls-2,.cls-3{fill:none;}.cls-3{stroke-width:3.09px;}.cls-4{font-size:22.63px;font-family:Montserrat-Bold, Montserrat;font-weight:700;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "price") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 31.96,
    y1: 101.38,
    x2: 50.34,
    y2: 101.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 41.15,
    y1: 101.38,
    x2: 41.15,
    y2: 34.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.81,74.65s-24.65-4.6-24.65-15.88S3.56,38.3,3.56,38.3c7.52-1.67,18.79,3.76,25.48,7.52S39.9,74.65,39.9,74.65L18.18,47.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.09,63.4s24.64-4.59,24.64-15.87,9.61-20.47,9.61-20.47c-7.52-1.67-18.8,3.76-25.48,7.52S43,63.4,43,63.4L64.72,36.67"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 41.15,
    cy: 17.83,
    r: 16.29
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(34.89 24.94)"
  }, "$")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice);
export default __webpack_public_path__ + "static/media/price.6d5c4e67b3bc323b3a5dbfa475dbd68d.svg";
export { ForwardRef as ReactComponent };